export default __webpack_public_path__ + "18af8c75ab1951a5e56d544fb858e766.woff";